import { jsx, jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import {
  ColorPicker as ColorPickerComponent,
  SelectTrigger
} from "../../../../components/ColorPicker/index.js";
import { FormControl, FormHelperText } from "@mui/material";
import { useTidalFormBridge } from "../../utils/useTidalFormBridge.js";
const defaultComponentValue = "#000000";
function ColorPicker(props) {
  const [open, onSetOpen] = useState(() => false);
  const {
    initialValue = defaultComponentValue,
    validateOn = "change",
    colorPickerProps,
    palette: topLevelPalette,
    picker: topLevelPicker,
    disableAutomaticTrigger,
    ...bridgeOptions
  } = props;
  const {
    config: { label, fullWidth, testId = "ColorPicker-field--root" },
    fieldInfo: {
      errorOrHelperText,
      field: { required, visible },
      fieldHasError,
      onChange,
      showHelperText,
      showErrorText,
      value
    }
  } = useTidalFormBridge({
    ...bridgeOptions,
    validateOn,
    initialValue
  });
  const localeText = useInjectLabelIntoLocaleText(label, colorPickerProps?.localeText);
  const handleOnChange = (value2) => {
    onChange(value2);
  };
  const providedTrigger = colorPickerProps?.trigger;
  const trigger = useMemo(
    () => providedTrigger ? providedTrigger : !disableAutomaticTrigger ? { Component: SelectTrigger, open, onSetOpen } : void 0,
    [open, providedTrigger, disableAutomaticTrigger]
  );
  if (!visible) return null;
  return /* @__PURE__ */ jsxs(
    FormControl,
    {
      error: fieldHasError,
      component: "fieldset",
      variant: "standard",
      fullWidth,
      "data-testid": testId,
      "data-tidal": "ColorPicker-Field",
      required,
      "data-tidal-form-field-name": bridgeOptions.name,
      sx: {
        "&.tidal-form-devtool-highlight": (theme) => ({
          outline: `4px solid var(--tidal-devtools-highlight-color, ${theme.vars.palette.error.dark})`
        })
      },
      children: [
        /* @__PURE__ */ jsx(
          ColorPickerComponent,
          {
            value,
            onColorChange: handleOnChange,
            ...colorPickerProps,
            trigger,
            localeText,
            testId,
            palette: topLevelPalette || colorPickerProps?.palette,
            picker: topLevelPicker || colorPickerProps?.picker
          }
        ),
        showHelperText && /* @__PURE__ */ jsx(FormHelperText, { error: fieldHasError, children: errorOrHelperText })
      ]
    }
  );
}
const useInjectLabelIntoLocaleText = (label, localeText = {}) => {
  return useMemo(() => {
    if (!label) return localeText;
    const stringLabel = String(label);
    return {
      triggerSelectLabel: stringLabel,
      ...localeText
    };
  }, [label, localeText]);
};
export {
  ColorPicker
};
//# sourceMappingURL=ColorPicker.js.map
